<div class="menu-items">
  <div class="menu-items__wrapper" *ngFor="let item of items; let last=last">
    <div class="menu-items__item" [class.menu-items__item-last]="last">
      <button
        (click)="selectItem(item)"
        [ngClass]="{'selected-item' : isSelected(item)}"
        type="button"
        class="menu-items__btn">
        {{item.param}}
      </button>
    </div>
  </div>
</div>
